import styled from 'styled-components';
import { spacing, positioning } from 'ui/theme/utils';

export const Image = styled.img.attrs(({ onError = (err) => console.error(err) }) => ({
  onError,
}))`
  width: ${({ width = 'auto' }) => width};
  ${({ height }) => height && `height: ${height};`}
  ${({ cursor }) => cursor && `cursor: ${cursor};`}
  ${(props) => `
    ${spacing(props)}
    ${positioning(props)}
  `}
`;
